import math from "./mathInstance";
import { polynomial, randomNum } from "./operations";

export type BaseScope = {
  _check: boolean;
  _seed: number;
  [key: string]: any;
};

/**
 * You can see this as also an extendMath,
 * but this one has access to scope (aka side-effects).
 *  */
export function initScope(
  seed: number = Math.floor(Math.random() * 1e9)
): BaseScope {
  /**
   * _check must be true if ALL check() calls received a true argument, false otherwise
   * more info: https://github.com/SenecaLabs/senecaWeb/issues/12337#:~:text=are%20functionally%20equal.-,check(),-check(condition%3A%20boolean)
   * **/

  const scope: BaseScope = { _check: true, _seed: seed };

  scope.check = (condition: boolean) => {
    scope._check = scope._check && condition;
  };

  scope.pick = math.typed("pick", {
    "BigNumber, BigNumber": function (a, b) {
      return math.bignumber(
        randomNum({
          scope,
          min: math.number(a),
          max: math.number(b)
        })
      );
    },
    "BigNumber, BigNumber, BigNumber": function (a, b, c) {
      return math.bignumber(
        randomNum({
          scope,
          min: math.number(a),
          max: math.number(b),
          decimals: math.number(c)
        })
      );
    },
    Array: function (array) {
      return array[
        randomNum({
          scope,
          min: 0,
          max: array.length - 1
        })
      ];
    }
  });

  scope.polynomial = (args: any) => {
    return polynomial({ ...args, scope });
  };

  return scope;
}
